// utils/markdown.js
// Shared Markdown renderer for assistant messages: markdown-it (GFM) + DOMPurify sanitize.
import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

const md = new MarkdownIt({
  html: false,      // don't pass raw HTML through (defense-in-depth alongside DOMPurify)
  linkify: true,    // auto-link bare URLs
  breaks: true      // single newlines -> <br>, matching the chat's line-break feel
})

// Open every link in a new tab safely.
const defaultLinkOpen = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options)
}
md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  const token = tokens[idx]
  token.attrSet('target', '_blank')
  token.attrSet('rel', 'noopener noreferrer')
  return defaultLinkOpen(tokens, idx, options, env, self)
}

// Render Markdown text to sanitized HTML.
export function renderMarkdown(text) {
  if (typeof text !== 'string' || text.length === 0) return ''
  const html = md.render(text)
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })
}
